import { requst } from '../config'

// 日历上数据
export const getWorkboatCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/workboat/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getWorkboatDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询日期
export const getWorkboatByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/workboat/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getWorkboatByIdApi = id => {
    const url = `/monitor/workboat/${id}`
    return requst.get(url)
}

// 获取 Activities 数据
export const getWorkboatActivitiesDataApi = id => {
    const url = `/monitor/workboat/activity/list?workboatId=${id}`
    return requst.get(url)
}

// 提交 Workboat 总结
export const postWorkboatCommentApi = commentData => {
    const url = `/monitor/workboat`
    return requst.post(url, { ...commentData })
}

// 修改 Workboat 总结
export const putWorkboatCommentApi = (commentData, id) => {
    const url = `/monitor/workboat`
    return requst.put(url, { ...commentData, id })
}

// 提交 Activities 数据
export const postWorkboatActivitiesDataApi = (activitiesParams, id) => {
    const url = `/monitor/workboat/activity/addOrUpdateBatch/${id}`
    return requst.post(url, activitiesParams)
}
